import React from 'react'
import Page from '../../components/Page/Page'
import Event from '../../components/University/Event'
import Report from '../../components/University/Report'
import Link from '../../components/University/Link'
import PageTitle from '../../components/University/PageTitle'
import Project from '../../components/University/Project'
import CategoryProvider from '../../components/University/CategoryContext'

const title = '新潟大学向け'

const Niigata = () => {
  return (
    <CategoryProvider category="niigata">
      <Page title={title}>
        <PageTitle />
        <Project />
        <Event />
        <Report />
        <Link linkMedical="https://www.med.niigata-u.ac.jp/" />
      </Page>
    </CategoryProvider>
  )
}

export default Niigata
